import { createFileRoute } from "@tanstack/react-router";
import { PlusPage } from "@/components/dashboard/plus-page";

export const Route = createFileRoute("/plus")({
  head: () => ({
    meta: [
      { title: "Deuxda Plus & ads — Deuxda Admin" },
      { name: "description", content: "Grant Deuxda Plus and manage feed ads." },
    ],
  }),
  component: () => <PlusPage />,
});
